export default "__VITE_ASSET__DWOzoixE__"